// Brand + client logo assets
// Company logo is optimized & served locally from /public (transparent, ~112KB).
export const COMPANY_LOGO = "/logo.png";

const BASE =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_jagdambay-india/artifacts";

const ADANI = `${BASE}/ph5tkwcp_Adani-power-logo.png`;
const JINDAL = `${BASE}/6b6s1ukz_jindal_power_limited_logo.jpeg`;
const KPCL = `${BASE}/bpq2o8bo_kpcl%20logo.jpeg`;
const NFL = `${BASE}/nl6j896n_swarajya_2021-02_0a00d109-8dc2-4c33-a602-d2fa427acd4f_NFL_logo__Pic_Via_Wikipedia_.webp`;
const JSW = `${BASE}/pz1nijmf_png-clipart-logo-jsw-steel-ltd-design-brand-jsw-group-president-election-india-2017-text-trademark.png`;
const RVUNL = `${BASE}/8tqg1mjg_RajasthanRajyaVidyut.png`;
const LT = `${BASE}/p1erq0y9_larsen-toubro-limited-vector-logo-115742.png`;
const IOCL = `${BASE}/zqo8t4ft_iocl.webp`;

// logo: direct asset url (preferred). domain: clearbit fallback if a logo ever fails.
export const CLIENTS = [
  { name: "ADANI", logo: ADANI, domain: "adani.com" },
  { name: "JSW", logo: JSW, domain: "jsw.in" },
  { name: "KPCL", logo: KPCL, domain: "karnatakapower.com" },
  { name: "JINDAL POWER", logo: JINDAL, domain: "jindalpower.com" },
  { name: "RVUNL", logo: RVUNL, domain: "rvunl.com" },
  { name: "L&T", logo: LT, domain: "larsentoubro.com" },
  { name: "NFL", logo: NFL, domain: "nationalfertilizers.com" },
  { name: "IOCL", logo: IOCL, domain: "iocl.com" },
];
